function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1924(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30.56,
    height: 19.21,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2016666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 9.605
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.21,
    width: 30.56,
    height: 24.47,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.718888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 31.445
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 43.69,
    width: 30.56,
    height: 27.2,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.533333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 57.29
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 70.89,
    width: 30.56,
    height: 28.4,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 85.09
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 99.3,
    width: 30.56,
    height: 29.07,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.814
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 113.835
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 128.37,
    width: 30.56,
    height: 29.8,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 143.27
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 158.17,
    width: 30.56,
    height: 32.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 174.385
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 190.6,
    width: 30.56,
    height: 36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.365714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 208.6
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 226.6,
    width: 30.56,
    height: 36.59,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 244.89499999999998
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 263.19,
    width: 30.56,
    height: 41.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.365714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 284.12
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 305.05,
    width: 30.56,
    height: 42.99,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 326.545
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 348.04,
    width: 30.56,
    height: 43.55,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.093333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 369.815
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 391.59,
    width: 30.56,
    height: 48.12,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.093333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 415.65
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 439.71,
    width: 30.56,
    height: 48.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 463.96999999999997
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 488.22,
    width: 30.56,
    height: 51.48,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.365714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 513.96
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 539.7,
    width: 30.56,
    height: 51.71,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.056
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 565.5550000000001
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 591.41,
    width: 30.56,
    height: 52.48,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.093333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 617.65
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 643.89,
    width: 30.56,
    height: 56.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.28,
    y: 671.9449999999999
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 0,
    width: 37.84,
    height: 46.32,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7840000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.480000000000004,
    y: 23.16
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.4,
    y: 0,
    width: 38.63,
    height: 46.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4383333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.715,
    y: 23.16
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.03,
    y: 0,
    width: 40.04,
    height: 46.32,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 127.05,
    y: 23.16
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.08,
    y: 0,
    width: 42.81,
    height: 46.32,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.135000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 168.485,
    y: 23.16
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.88,
    y: 0,
    width: 43.27,
    height: 46.32,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.211666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.515,
    y: 23.16
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.15,
    y: 0,
    width: 45.27,
    height: 46.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.785,
    y: 23.16
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.42,
    y: 0,
    width: 48.85,
    height: 46.32,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.845,
    y: 23.16
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.27,
    y: 0,
    width: 49.13,
    height: 46.32,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.835,
    y: 23.16
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.4,
    y: 0,
    width: 50.65,
    height: 46.32,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.72499999999997,
    y: 23.16
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.05,
    y: 0,
    width: 51.84,
    height: 46.32,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.97,
    y: 23.16
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.89,
    y: 0,
    width: 53.92,
    height: 46.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1466666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.84999999999997,
    y: 23.16
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532.81,
    y: 0,
    width: 55,
    height: 46.32,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.264
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.31,
    y: 23.16
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.81,
    y: 0,
    width: 56.1,
    height: 46.32,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1466666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.8599999999999,
    y: 23.16
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 643.9,
    y: 0,
    width: 56.1,
    height: 46.32,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.9499999999999,
    y: 23.16
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 46.32,
    width: 55.13,
    height: 47.24,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.448
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.125,
    y: 69.94
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 93.57,
    width: 55.13,
    height: 48.05,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.008333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.125,
    y: 117.595
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 141.62,
    width: 55.13,
    height: 48.39,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.678
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.125,
    y: 165.815
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 190.01,
    width: 55.13,
    height: 49.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.525555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.125,
    y: 214.875
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 239.74,
    width: 55.13,
    height: 50.38,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.396666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.125,
    y: 264.93
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 290.12,
    width: 55.13,
    height: 53.2,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.911111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.125,
    y: 316.72
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 343.32,
    width: 55.13,
    height: 55.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.188333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.125,
    y: 371.09499999999997
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 398.87,
    width: 55.13,
    height: 56.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.7825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.125,
    y: 427.205
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 455.54,
    width: 55.13,
    height: 59.74,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.89125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.125,
    y: 485.41
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 515.28,
    width: 55.13,
    height: 60.42,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.188333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.125,
    y: 545.49
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 575.69,
    width: 55.13,
    height: 61.1,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.188333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.125,
    y: 606.24
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.56,
    y: 636.8,
    width: 55.13,
    height: 63.2,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.026
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.125,
    y: 668.4
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.69,
    y: 46.32,
    width: 54.96,
    height: 66.33,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.851428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.17,
    y: 79.485
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.65,
    y: 46.32,
    width: 55.41,
    height: 66.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.6175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 168.35500000000002,
    y: 79.485
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.06,
    y: 46.32,
    width: 57.75,
    height: 66.33,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.4375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 224.935,
    y: 79.485
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.81,
    y: 46.32,
    width: 60.91,
    height: 66.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.181999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.265,
    y: 79.485
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.73,
    y: 46.32,
    width: 62.57,
    height: 66.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.82125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 346.01500000000004,
    y: 79.485
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.3,
    y: 46.32,
    width: 62.63,
    height: 66.33,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.6575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.615,
    y: 79.485
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.93,
    y: 46.32,
    width: 63.35,
    height: 66.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.91875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 471.605,
    y: 79.485
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.28,
    y: 46.32,
    width: 64.6,
    height: 66.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.919999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 535.5799999999999,
    y: 79.485
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.88,
    y: 46.32,
    width: 65.67,
    height: 66.33,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.715,
    y: 79.485
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.55,
    y: 46.32,
    width: 66.45,
    height: 66.33,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.633
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.775,
    y: 79.485
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.69,
    y: 112.65,
    width: 71.53,
    height: 62.47,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.924285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.455,
    y: 143.885
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.69,
    y: 175.12,
    width: 71.53,
    height: 62.75,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.84375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.455,
    y: 206.495
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.69,
    y: 237.87,
    width: 71.53,
    height: 63.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.744
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.455,
    y: 269.73
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.69,
    y: 301.59,
    width: 71.53,
    height: 64.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.674999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.455,
    y: 333.61499999999995
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.69,
    y: 365.64,
    width: 71.53,
    height: 64.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.493
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.455,
    y: 398.105
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.69,
    y: 430.57,
    width: 71.53,
    height: 66.04,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.255
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.455,
    y: 463.59
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.69,
    y: 496.61,
    width: 71.53,
    height: 67.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.503333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.455,
    y: 530.375
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.69,
    y: 564.14,
    width: 71.53,
    height: 67.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.305
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.455,
    y: 598.055
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.69,
    y: 631.97,
    width: 71.53,
    height: 68.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.606
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.455,
    y: 665.985
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.22,
    y: 112.65,
    width: 62.64,
    height: 77.75,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.528
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.54,
    y: 151.525
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.87,
    y: 112.65,
    width: 62.77,
    height: 77.75,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.967142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.255,
    y: 151.525
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.64,
    y: 112.65,
    width: 63.27,
    height: 77.75,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.275,
    y: 151.525
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.91,
    y: 112.65,
    width: 65.93,
    height: 77.75,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.418571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 378.875,
    y: 151.525
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.84,
    y: 112.65,
    width: 68.62,
    height: 77.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.802857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.15,
    y: 151.525
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 480.47,
    y: 112.65,
    width: 72.35,
    height: 77.75,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.038888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.645,
    y: 151.525
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552.82,
    y: 112.65,
    width: 73.4,
    height: 77.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.485714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 589.5200000000001,
    y: 151.525
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 626.22,
    y: 112.65,
    width: 73.78,
    height: 77.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.2225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.11,
    y: 151.525
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.22,
    y: 190.4,
    width: 74.14,
    height: 80.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.2675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.29,
    y: 230.72500000000002
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.22,
    y: 271.06,
    width: 74.14,
    height: 81.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.59142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.29,
    y: 311.58
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.22,
    y: 352.09,
    width: 74.14,
    height: 85.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.59142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.29,
    y: 394.645
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.22,
    y: 437.21,
    width: 74.14,
    height: 85.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.59142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.29,
    y: 479.865
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.22,
    y: 522.51,
    width: 74.14,
    height: 86.87,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.29,
    y: 565.9449999999999
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.22,
    y: 609.38,
    width: 74.14,
    height: 90.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.237777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.29,
    y: 654.69
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.36,
    y: 190.4,
    width: 88.79,
    height: 80.55,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.507142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.755,
    y: 230.675
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.16,
    y: 190.4,
    width: 89.96,
    height: 80.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.14000000000004,
    y: 230.675
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.11,
    y: 190.4,
    width: 92.55,
    height: 80.55,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 456.385,
    y: 230.675
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 502.66,
    y: 190.4,
    width: 94.43,
    height: 80.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.424999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.875,
    y: 230.675
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.09,
    y: 190.4,
    width: 102.91,
    height: 80.55,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.06875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 648.5450000000001,
    y: 230.675
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.36,
    y: 270.96,
    width: 101.38,
    height: 81.81,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.635
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.05,
    y: 311.865
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.36,
    y: 352.76,
    width: 101.38,
    height: 81.99,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.24875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.05,
    y: 393.755
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.36,
    y: 434.75,
    width: 101.38,
    height: 83.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.05,
    y: 476.34000000000003
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.36,
    y: 517.93,
    width: 101.38,
    height: 90.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.059999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.05,
    y: 563.2299999999999
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.36,
    y: 608.53,
    width: 101.38,
    height: 91.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.05,
    y: 654.265
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.74,
    y: 270.96,
    width: 89.35,
    height: 107.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.869999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.415,
    y: 324.9
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.09,
    y: 270.96,
    width: 90.44,
    height: 107.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.305
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.30999999999995,
    y: 324.9
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512.53,
    y: 270.96,
    width: 91.75,
    height: 107.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.291666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 558.405,
    y: 324.9
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 604.27,
    y: 270.96,
    width: 95.73,
    height: 107.88,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.675714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 652.135,
    y: 324.9
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.74,
    y: 378.84,
    width: 105.85,
    height: 98.07,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.665,
    y: 427.875
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.74,
    y: 476.9,
    width: 105.85,
    height: 110.08,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.622727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.665,
    y: 531.9399999999999
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.74,
    y: 586.99,
    width: 105.85,
    height: 113.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.23125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.665,
    y: 643.495
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.59,
    y: 378.84,
    width: 130.25,
    height: 92.46,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 503.715,
    y: 425.07
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.84,
    y: 378.84,
    width: 131.16,
    height: 92.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.208571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.4200000000001,
    y: 425.07
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.59,
    y: 471.29,
    width: 115.53,
    height: 112.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.35499999999996,
    y: 527.61
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.59,
    y: 583.94,
    width: 115.53,
    height: 116.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.504285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.35499999999996,
    y: 641.97
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 554.11,
    y: 471.29,
    width: 145.89,
    height: 111.19,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.89875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.0550000000001,
    y: 526.885
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 554.11,
    y: 582.48,
    width: 145.89,
    height: 117.52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.0550000000001,
    y: 641.24
  }, "\n        Buncombe\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1924);
export default __webpack_public_path__ + "static/media/1924.94ea54da5dc771a00ea05f6afff0e2fa.svg";
export { ForwardRef as ReactComponent };